import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.light,
  flexGrow: 1,
  padding: "30px 0",
  minHeight: "calc(100vh - 200px)",

  // FE-34: там, где показывается липкая панель с ценой, последний блок
  // страницы иначе уезжает под неё. --sticky-bar-h публикует сама панель.
  [theme.down("lg")]: {
    paddingBottom: `calc(var(--sticky-bar-h, 0px) + ${theme.spacing(5)}px)`,
  },

  [theme.down("sm")]: {
    padding: "15px 0",
    paddingBottom: `calc(var(--sticky-bar-h, 0px) + ${theme.spacing(4)}px)`,
  },
}));

export const Block = styled("div")(({ theme }) => ({
  ...theme.mixins.flexJustifyBetween,
  alignItems: "flex-start",
  gap: 20,
  padding: "10px 0",

  [theme.down("lg")]: {
    flexDirection: "column",
    gap: 15,
  },

  [theme.down("sm")]: {
    padding: "5px 0",
  },
}));

export const RoutesDataAndFormBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  flexGrow: 1,
  minWidth: 0, // min-width: auto не давал колонке сжиматься уже своего контента
  gap: 20,

  [theme.down("lg")]: {
    order: 1,
    width: "100%",
  },

  [theme.down("sm")]: {
    gap: 15,
  },
}));
